import React, { useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import { useSnackbar } from 'notistack';

const Lotties = () => {
    const [validationResults, setValidationResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const validateLottieFile = (json) => {
        return !(json.assets && json.assets.some(asset => asset.e === 0));
    };

    const handleFilesChange = event => {
        setIsLoading(true);
        const files = Array.from(event.target.files);
        const results = [];

        files.forEach((file, index) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const json = JSON.parse(e.target.result);

                    if (validateLottieFile(json)) {
                        results.push({ file: file.name, isValid: true });
                        enqueueSnackbar(`${file.name} is valid.`, { variant: 'success' });
                    } else {
                        results.push({ file: file.name, isValid: false });
                        enqueueSnackbar(`${file.name} is INVALID.`, { variant: 'error' });
                    }
                } catch (error) {
                    results.push({ file: file.name, isValid: false });
                    enqueueSnackbar(`${file.name} has a JSON error.`, { variant: 'error' });
                }
                if (index === files.length - 1) {
                    setValidationResults(results);
                    setIsLoading(false);
                }
            };
            reader.readAsText(file);
        });
    };

    return (
        <Box 
            style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                justifyContent: 'center',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                border: '2px dashed lightgray', 
                backgroundColor: '#f5f5f5',
                padding: '20px', 
                width: '400px',
                height: '450px' 
            }}
        >
            {isLoading ? (
                <CircularProgress />
            ) : (
                <>
                    <input
                        accept="application/json"
                        id="upload-lotties"
                        type="file"
                        multiple
                        style={{ display: 'none' }}
                        onChange={handleFilesChange}
                    />
                    <label htmlFor="upload-lotties" style={{ cursor: 'pointer' }}>
                        <Box style={{ padding: '10px', textAlign: 'center', cursor: 'pointer', minHeight: '100px', position: 'relative' }}>
                            <ImageIcon style={{ fontSize: '60px', color: 'gray' }} />
                            <div style={{ marginTop: '10px' }}>
                                Click to upload Lottie files
                            </div>
                        </Box>
                    </label>
                    {validationResults.map(result => (
                        <Typography key={result.file} variant="body2" color="textSecondary" style={{ marginTop: '10px', textAlign: 'center' }}>
                            {result.file}: {result.isValid ? 'VALID' : 'INVALID'}
                        </Typography>
                    ))}
                </>
            )}
        </Box>
    );
};

export default Lotties;
